import { useIsBusinessPlan } from "../../helpers/subscriptionPlan";
import { useProfile } from "./useProfile";

const findKeyNeedsKeyword = (f) =>
  ["descriptionWithImage", "detail", "sku"].includes(f.key) && f.enabled;

export const useDeliveryOrderKeyword = () => {
  const { profile } = useProfile();
  const isBusinessPlan = useIsBusinessPlan();

  if (!isBusinessPlan) return false;

  const doTable = profile?.params?.doTable;
  const isFetchKeyword = doTable?.some(findKeyNeedsKeyword);

  return isFetchKeyword;
};

export const useInvoiceKeyword = () => {
  const { profile } = useProfile();
  const isBusinessPlan = useIsBusinessPlan();

  if (!isBusinessPlan) return false;

  const invoiceTable = profile?.params?.invoiceTable;
  const isFetchKeyword = invoiceTable?.some(findKeyNeedsKeyword);

  return isFetchKeyword;
};
